import { customDispatch } from "@affinity/Store/ServiceBase";
import { AffinityProduct, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

// External parameters
export interface SetProductParameters {
    selectedProduct: AffinityProduct,
}

// Internal parameters
interface Props {
    selectedProduct: ProductModelX,
}

type HandlerType = Handler<SetProductParameters, Props>;

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/Product/Set",
        product: props.parameter.selectedProduct,
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    UpdateState,
    Tracking,
];

const PlaceOrderSetProduct = createHandlerChainRunner(chain, "PlaceOrderSetProduct");
export default PlaceOrderSetProduct;